module.exports = __webpack_public_path__ + "img/1575403464.f3bdc16f.jpg";